import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { clearSearchResults } from '../../reducers/searchReducer';
import SearchTermContainer from '../search/containers/SearchTermContainer';

import DocsHeader from './docs-header.png';
import NyanHeader from './nyan.gif';

class Header extends React.Component {
	constructor(props) {
		super(props);

		this.handleEscKey = this.handleEscKey.bind(this);
	}

	handleEscKey(e) {
		if (e.keyCode === 27) {
			this.props.clearSearch();
		}
	}

	render() {
		return (
			<div className="header" onKeyDown={this.handleEscKey}>
				<ul>
					<li className="brand">
						<Link to="/">
							<img src={process.env.DOCS_TYPE === 'internal' ? NyanHeader : DocsHeader} alt="API Documentation" />
						</Link>
					</li>
					<li className="search">
						<SearchTermContainer />
						{this.props.searchTerm && <i className="fa fa-close close-icon" onClick={this.props.clearSearch}></i>}
					</li>
					<li>
						<NavLink exact to="/" onClick={this.props.clearSearch}>Home</NavLink>
					</li>
					<li>
						<NavLink to="/getting-started" onClick={this.props.clearSearch}>Getting Started</NavLink>
					</li>
					<li>
						<NavLink to="/api" onClick={this.props.clearSearch}>API Reference</NavLink>
					</li>
					{process.env.DOCS_TYPE === 'internal' &&
						<li>
							<NavLink to="/javascript-sdk" onClick={this.props.clearSearch}>JavaScript SDK</NavLink>
						</li>
					}
					{process.env.DOCS_TYPE === 'internal' &&
						<li>
							<NavLink to="/widgets" onClick={this.props.clearSearch}>Widgets</NavLink>
						</li>
					}
				</ul>
			</div>
		);
	}
}

Header.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	}).isRequired,
	clearSearch: PropTypes.func.isRequired,
	searchTerm: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		searchTerm: state.search.searchTerm
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		clearSearch: () => {
			dispatch(clearSearchResults());
		}
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));


// WEBPACK FOOTER //
// ./src/components/shared/Header.js